module.exports = __webpack_public_path__ + "static/media/mockup-chatgpt.dfbfd854.jpg";